import React, { useState, useEffect } from "react";
import axios from "axios";
import { alert_error, alert_success } from '../../../AppContext';
import { Cookies } from '../../../index.js';
// import ProfileNav from './ProfileNav.jsx';
import { useNavigate, Link, useLocation, useParams } from "react-router-dom";

const MyComponent = () => {
    return (
        <div className="mt-0">
            <div className="grid grid-cols-2 gap-1">
                <Link style={{ textDecoration: 'none' }} to="/reactapp/sunflower/facebook/subcheo?webappmode=showadview" className="max-w-7xl mx-2 py-2 mb-2">
                    <div className="relative group">
                        <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                        <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                            <div className="space-y-2">
                                <p className="text-lg text-slate-1000">
                                    <img
                                        src="https://hust.media/img/icon/followtiktok.jfif"
                                        className="h-7 w-7 cananh"
                                        alt="icon"
                                    />
                                    Follow Chéo nhận điểm
                                </p>
                                <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                    Active →
                                </div>
                                <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                            </div>
                        </div>
                    </div>
                </Link>
                <Link style={{ textDecoration: 'none' }} to="/reactapp/sunflower/facebook/cmtcheo?webappmode=showadview" className="max-w-7xl mx-2 py-2 mb-2">
                    <div className="relative group">
                        <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                        <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                            <div className="space-y-2">
                                <p className="text-lg text-slate-1000">
                                    <img
                                        src="https://hust.media/img/icon/comment.png"
                                        className="h-7 w-7 cananh"
                                        alt="icon"
                                    />
                                    Cmts nhận điểm
                                </p>
                                <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                    Active →
                                </div>
                                <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                            </div>
                        </div>
                    </div>
                </Link>
                <Link style={{ textDecoration: 'none' }} to="/reactapp/sunflower/facebook/camxucvipcheo?webappmode=showadview" className="max-w-7xl mx-2 py-2 mb-2">
                    <div className="relative group">
                        <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                        <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                            <div className="space-y-2">
                                <p className="text-lg text-slate-1000">
                                    <img
                                        src="https://hust.media/img/icon/timins.png"
                                        className="h-7 w-7 cananh"
                                        alt="icon"
                                    />
                                    Thả reacts nhận điểm Pro
                                </p>
                                <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                    Rate cao, sl ít →
                                </div>
                                <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                            </div>
                        </div>
                    </div>
                </Link>
                <Link style={{ textDecoration: 'none' }} to="/reactapp/sunflower/facebook/camxuccheo?webappmode=showadview" className="max-w-7xl mx-2 py-2 mb-2">
                    <div className="relative group">
                        <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                        <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                            <div className="space-y-2">
                                <p className="text-lg text-slate-1000">
                                    <img
                                        src="https://hust.media/img/icon/timins.png"
                                        className="h-7 w-7 cananh"
                                        alt="icon"
                                    />
                                    Thả reacts nhận điểm Base
                                </p>
                                <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                    Rate thấp, sl nhiều →
                                </div>
                                <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                            </div>
                        </div>
                    </div>
                </Link>
                <Link style={{ textDecoration: 'none' }} to="/reactapp/sunflower/facebook/danhgiapage?webappmode=showadview" className="max-w-7xl mx-2 py-2 mb-2">
                    <div className="relative group">
                        <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                        <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                            <div className="space-y-2">
                                <p className="text-lg text-slate-1000">
                                    <img
                                        src="https://tecom.pro/img/icon/likepageicon.png"
                                        className="h-7 w-7 cananh"
                                        alt="icon"
                                    />
                                    Reviews page nhận điểm
                                </p>
                                <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                    Active →
                                </div>
                                <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                            </div>
                        </div>
                    </div>
                </Link>
                <Link style={{ textDecoration: 'none' }} to="/reactapp/sunflower/facebook/thamgianhomcheo?webappmode=showadview" className="max-w-7xl mx-2 py-2 mb-2">
                    <div className="relative group">
                        <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                        <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                            <div className="space-y-2">
                                <p className="text-lg text-slate-1000">
                                    <img
                                        src="https://tecom.pro/img/icon/followfb.svg"
                                        className="h-7 w-7 cananh"
                                        alt="icon"
                                    />
                                    Tham gia nhóm
                                </p>
                                <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                    Nếu hiện jop phải làm luôn ko ấn tải lại →
                                </div>
                                <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                            </div>
                        </div>
                    </div>
                </Link>
                <Link style={{ textDecoration: 'none' }} to="/reactapp/exchangepoints?webappmode=showadview" className="max-w-7xl mx-2 py-2 mb-2">
                    <div className="relative group">
                        <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                        <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                            <div className="space-y-2">
                                <p className="text-lg text-slate-1000">
                                    Đổi điểm sang Coins
                                </p>
                                <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                    Active →
                                </div>
                                <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        </div>

    );
};

export default MyComponent;
